import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  NavLink,
  Link
} from 'react-router-dom';
import logo from './logo.svg';
import Home from './Home';
import Who from './Who';
import What from './What';
import './App.css';

class App extends Component {

  state = {
    isMobileNavVisible: false
  }

  showMobileNav = () => this.setState({ isMobileNavVisible: true })

  hideMobileNav = () => this.setState({ isMobileNavVisible: false })

  render() {
    var navClasses = ['app-nav'];

    if (this.state.isMobileNavVisible) {
      navClasses.push('visible');
    }

    return (
      <Router>
        <div className="app">
          <div className="app-header">
            <header>
              <img src={logo} className="app-logo" alt="logo" style={{ width: '60px', height: '60px' }} />
              <Link to="/">
                <h1>Closing Bot</h1>
                <small>Listing Coordination &middot; Contract Management</small>
              </Link>
            </header>
            <button className="app-mobile-nav-toggle" onClick={this.showMobileNav}>
              <span />
              <span />
              <span />
            </button>
            <nav className={navClasses.join(' ')}>
              <button className="close-button" onClick={this.hideMobileNav}>&times;</button>
              <div className="app-nav-content">
                <NavLink onClick={this.hideMobileNav} activeClassName="active" to="/what-we-do">What We Do</NavLink>
                <NavLink onClick={this.hideMobileNav} activeClassName="active" to="/who-we-are">Who We Are</NavLink>
                <a href="mailto:info@closingbot.com">Contact</a>
              </div>
            </nav>
          </div>
          <main className="app-main">
            <Route exact path="/" component={Home} />
            <Route path="/who-we-are" component={Who} />
            <Route path="/what-we-do" component={What} />
          </main>
          <footer className="app-footer">
            <div className="app-footer-content">
              Closing Bot &middot; 404.333.3114 &middot; <a href="mailto:info@closingbot.com">info@closingbot.com</a>
            </div>
          </footer>
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js